import React, { useState, useEffect } from "react";
// import { useFeatureIsOn } from "@growthbook/growthbook-react";
// import Button from "../../components/common/button";
import Loader from "../../components/common/loader/loader";
import useThankYouLogic from "./hooks/useThankYou";
import ShareComponent from "../../components/shareModal/ShareComponent";
import VolumeMute from "./../../assets/images/Mute.svg";
import VolumeFull from "./../../assets/images/volume-full.svg";
// import useColinkExist from "../../services/hooks/useColinkExist";
// import FollowingCheck from "../../assets/images/following-check.svg";
import ShareIcon from "./../../assets/images/shareIconBlackFill.svg";
import {
  generateCloudinaryImageUrl,
  generateCloudinaryVideoThumbnail,
  generateCloudinaryVideoUrl,
  generateProfileImageUrl,
  getLocalStorage
} from "../../utils/common-function";
import mixpanel from "../../services/mixpanelService";
import WaitlistModal from "../../components/waitlistModal";
import { envVariables, isAmazonCampaign, isNativeWebview } from "../../common/constants";
import useWaitlist from "./hooks/useWaitlist";
import { SampleEligibleBrandsData } from "../../types";
import ContinueModal from "../../components/continueModal";
import clsx from "clsx";
import { PlayIcon } from "./playIcon";
import { useHistory } from "react-router";
import { routes } from "../../routes/routes.constant";
import { positionButtonForInAppBrowser } from "../../utils/positionButtonForInAppBrowser";

const ThankYou: React.FC = () => {
  const {
    videoRef,
    stashlink,
    navigateToColink,
    navigateToStashAgain,
    parentVideoRef,
    userData,
    campaign,
    showParentVideo,
    parentVideoProgress,
    videoProgress,
    muted,
    setMuted,
    isShareModalOpen,
    setIsShareModalOpen,
    isContinueModalOpen,
    setIsContinueModalOpen,
    changeParentTab
  } = useThankYouLogic();
  // const { colinkExistData } = useColinkExist(stashlink?.id || "");
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isColinkVideoLoading, setIsColinkVideoLoading] = useState(true);
  const [hasPausedBefore, setPausedBefore] = useState(false);
  const [dynamicImageSize, setDynamicImageSize] = useState({ width: "", height: "" });
  const gamePlayCount = getLocalStorage("gamePlayCount") as number;
  const navigation = useHistory();

  // const onboardingFeatureFlag = useFeatureIsOn("onboarding-flow");
  // const userId = getLocalStorage("userId") as string;
  const coinDropId = getLocalStorage("coinDropId");
  const brandData = getLocalStorage("brandsData") as SampleEligibleBrandsData;

  const colinkVideoUrl = stashlink.thankYouMessageVideo?.replace(".mkv", ".mp4") ?? "";
  const parentVideoUrl = stashlink.parentStashlink?.thankYouMessageVideo?.replace(".mkv", ".mp4") ?? "";
  const colinkVideoThumbnail =
    stashlink.thankYouMessageVideo && generateCloudinaryVideoThumbnail(stashlink.thankYouMessageVideo, "750", "930", 1); // Example for generating thumbnail
  const parentVideoThumbnail =
    stashlink.parentStashlink?.thankYouMessageVideo &&
    generateCloudinaryVideoThumbnail(stashlink.parentStashlink?.thankYouMessageVideo, "750", "930", 1);
  const isAmazon = isAmazonCampaign(stashlink?.id);
  const shareUrl = `${envVariables.domainUrl}/stashlink/${stashlink.id}`;
  const { isWaitlistModalOpen, setWaitlistModalOpen } = useWaitlist();

  const closeWaitListModal = () => {
    setWaitlistModalOpen(false);
  };

  const closeContinueModal = () => {
    setIsContinueModalOpen(false);
  };

  const hasNextOrPreviousMedia = () => {
    const hasParentMedia = !!stashlink.parentStashlink?.id;
    return hasParentMedia;
  };

  useEffect(() => {
    const handleResize = () => {
      const windowHeight = window.innerHeight;
      if (windowHeight < 720) {
        setDynamicImageSize({ width: "560", height: "560" });
      } else {
        setDynamicImageSize({ width: "800", height: "1200" });
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isNativeBrowser = isNativeWebview();

  const shouldShowCTA = !isContinueModalOpen && !isShareModalOpen;

  useEffect(() => {
    if (!shouldShowCTA) return;

    const run = () => positionButtonForInAppBrowser();

    run();

    const t1 = setTimeout(run, 0);
    const t2 = setTimeout(run, 800);

    window.visualViewport?.addEventListener("resize", run);
    window.addEventListener("orientationchange", run);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      window.visualViewport?.removeEventListener("resize", run);
      window.removeEventListener("orientationchange", run);
    };
  }, [shouldShowCTA]);

  const CTA = (
    <div>
      <div
        id="bigPrimaryBtn"
        className={`left-0 w-full flex flex-col z-10 items-center justify-center  ${isNativeBrowser ? "bg-black pt-2 pb-3" : "fixed bottom-0 pb-6 pt-8 bg-gradient-to-t from-soft-black from-50% via-soft-black/70 via-70% to-soft-black/1 to-100% "}`}>
        {showParentVideo &&
          (stashlink.parentStashlink?.thankYouMessageVideo && showParentVideo ? (
            <div></div>
          ) : (
            <div className="relative top-0 left-0 w-full h-full">
              <div className="w-full">
                <p className="bg-gradient-to-t from-soft-black from-40% via-soft-black/70 via-70% to-base-white/0 to-90% text-white text-base leading-tight-19 text-center w-full p-4 px-5 pb-5 pt-16 [text-shadow:_1px_1px_0_rgb(0_0_0_/_60%)] inter-I">
                  {stashlink.parentStashlink?.thankYouMessage}
                </p>
              </div>
            </div>
          ))}

        {!showParentVideo &&
          (stashlink.thankYouMessageVideo ? (
            <div></div>
          ) : (
            <div className="relative w-full h-full">
              <div className="w-full">
                <p className="bg-gradient-to-t from-soft-black from-40% via-soft-black/70 via-70% to-base-white/0 to-90% text-white text-base leading-tight-19 text-center w-full p-4 px-5 pb-5 pt-16 [text-shadow:_1px_1px_0_rgb(0_0_0_/_60%)] inter-I">
                  {stashlink?.thankYouMessage}
                </p>
              </div>
            </div>
          ))}
        <div className="w-full flex flex-col gap-3 items-center px-4">
          {isAmazon ? (
            <>
              {gamePlayCount > 1 ? (
                <button
                  onClick={() => {
                    mixpanel.track(`share-button-${isNativeBrowser ? "top-" : ""}clicked`, {
                      campaignName: campaign?.title,
                      charityName: campaign?.charity?.name,
                      stashlinkId: stashlink?.id
                    });
                    setIsShareModalOpen(true);
                  }}
                  className="w-full flex items-center justify-center p-3 min-w-[283px] mb-1 bg-primary-l1 h-12 border-2 border-black tracking-wide leading-snug text-black text-center text-lg font-primary font-wght-750 shadow-[0px_4px_0px_#6C801F] select-none rounded-full whitespace-pre-wrap">
                  Share
                  <img className="text-black h-[26px] w-[26px] ml-1" src={ShareIcon} alt={ShareIcon} />
                </button>
              ) : (
                <button
                  onClick={() => {
                    mixpanel.track(`plan-again-${isNativeBrowser ? "top-" : ""}clicked`, {
                      campaignName: campaign?.title,
                      charityName: campaign?.charity?.name,
                      stashlinkId: stashlink?.id
                    });
                    navigation.replace({ ...location, state: {} });
                    navigation.replace(routes.bubblePop, { fromValidFlow: true });
                  }}
                  className="w-full flex items-center justify-center p-3 min-w-[283px] mb-1 bg-primary-l1 h-12 border-2 border-black tracking-wide leading-snug text-black text-center text-lg font-primary font-wght-750 shadow-[0px_4px_0px_#6C801F] select-none rounded-full whitespace-pre-wrap">
                  🌳 Unlock more trees 🌳
                </button>
              )}
            </>
          ) : (
            <>
              <button
                onClick={() => {
                  mixpanel.track(`share-button-${isNativeBrowser ? "top-" : ""}clicked`, {
                    campaignName: campaign?.title,
                    charityName: campaign?.charity?.name,
                    stashlinkId: stashlink?.id
                  });
                  setIsShareModalOpen(true);
                }}
                className="w-full flex items-center justify-center p-3 min-w-[283px] mb-1 bg-primary-l1 h-12 border-2 border-black tracking-wide leading-snug text-black text-center text-lg font-primary font-wght-750 shadow-[0px_4px_0px_#6C801F] select-none rounded-full">
                Share
                <img className="text-black h-[26px] w-[26px] ml-1" src={ShareIcon} alt={ShareIcon} />
              </button>
              <button
                onClick={() => {
                  mixpanel.track(`continue-button-${isNativeBrowser ? "top-" : ""}clicked-thank-you`, {
                    campaignName: campaign?.title,
                    charityName: campaign?.charity?.name,
                    stashlinkId: stashlink?.id
                  });
                  navigateToStashAgain();
                }}
                className="w-full flex items-center justify-center p-3 min-w-[283px] mb-5 bg-grey-op70/15  rounded-full h-12 border border-grey-op70 text-neutral-50 tracking-wide text-center text-sm font-primary font-wght-740 leading-tight-16.8 select-none">
                Continue
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );

  return !stashlink ? (
    <div className="h-[calc(100vh-80px)] w-screen flex justify-center items-center bg-soft-black">
      <Loader />
    </div>
  ) : (
    <>
      <div
        className={`text-sm w-full min-h-7 text-white flex items-center justify-center px-2 py-0.5 ${isNativeWebview() ? "bg-black" : "bg-grey-bg "}`}>
        <a className="no-underline w-full" href="https://www.stashrun.com/donation-disclosures">
          {isAmazon ? (
            <a href="https://www.stashrun.com/donation-disclosures" target="_blank" rel="noreferrer">
              <div className="space-x-2 px-4 truncate line-clamp-1 block text-center">
                Tree planted and protected! Confirmation{" "}
                <b>
                  <u>#{coinDropId}</u>
                </b>
              </div>
            </a>
          ) : (
            `🎉 $1.00 donated! Receipt #${coinDropId}`
          )}
        </a>
      </div>
      {isNativeWebview() && CTA}
      <div
        className={`relative  w-screen flex flex-col items-center overflow-hidden ${isNativeWebview() ? "h-full" : "h-[calc(100vh-76px)]"}`}>
        <div className="w-full h-24 absolute z-10 top-0 bg-gradient-to-b from-soft-black/70 from-30% via-soft-black/60 via-60% to-soft-black/1 to-100%"></div>
        <div className={`absolute top-2 w-[calc(100vw-24px)] ${stashlink.parentStashlink && "grid grid-cols-2 gap-2"}`}>
          {stashlink.parentStashlink && (
            <div className="relative bg-grey w-full h-0.5 rounded-xl z-10">
              <div
                className="bg-base-white absolute left-0 h-0.5 thank-you-progress-bar"
                style={{ width: `${parentVideoProgress}%` }}></div>
            </div>
          )}
          <div className="relative bg-grey w-full h-0.5 rounded-xl z-10">
            <div className="bg-base-white absolute left-0 h-0.5 thank-you-progress-bar" style={{ width: `${videoProgress}%` }}></div>
          </div>
        </div>

        <div className="absolute top-5 left-3 z-10 flex items-start justify-between right-3">
          <div className="flex flex-col space-y-2">
            <div className="font-[750] text-base text-neutral-50 [text-shadow:_2px_2px_0_rgb(0_0_0_/_30%)]">
              <b className="font-primary [text-shadow:_1px_1px_0_rgb(0_0_0_/_60%);]">
                {showParentVideo ? stashlink.parentStashlink?.user.fullName : stashlink.user.fullName}
              </b>
              <div className="text-sm text-neutral-50 font-normal [text-shadow:_1px_1px_0_rgb(0_0_0_/_60%);]">
                for{" "}
                <b className="font-semibold [text-shadow:_1px_1px_0_rgb(0_0_0_/_60%);]">
                  {brandData.sampleEligibleBrands?.campaign.charity?.name}
                </b>
              </div>
            </div>

            <div className="relative flex items-center -space-x-2.5">
              <img
                src={
                  showParentVideo
                    ? generateProfileImageUrl(stashlink.parentStashlink?.user.profilePhoto || "", "65", "65")
                    : generateProfileImageUrl(stashlink.user.profilePhoto || "", "65", "65")
                }
                width="36px"
                height="36px"
                alt={showParentVideo ? stashlink.parentStashlink?.user.fullName : stashlink.user.fullName}
                className="rounded-full object-cover"
              />
              <img
                src={generateCloudinaryImageUrl(brandData.sampleEligibleBrands?.campaign.charity?.imageUrl || "", "65", "65")}
                alt="charity logo"
                width="36px"
                height="36px"
                className="object-cover rounded-full border-2 border-soft-black z-20"
              />
            </div>
          </div>
          {((!showParentVideo && stashlink.thankYouMessageVideo) ||
            (showParentVideo && stashlink.parentStashlink?.thankYouMessageVideo)) && (
            <div className="relative flex items-center justify-center h-12 w-12">
              <img
                src={muted ? VolumeMute : VolumeFull}
                alt={VolumeFull}
                height={30}
                width={30}
                onClick={(event) => {
                  mixpanel.track("sound-clicked", {
                    location: "thank-you-page",
                    muted: !muted,
                    campaignName: campaign?.title,
                    stashlinkId: stashlink?.id
                  });
                  event.stopPropagation();
                  setMuted(!muted);
                }}
              />
            </div>
          )}
        </div>

        {showParentVideo &&
          (stashlink.parentStashlink?.thankYouMessageVideo && showParentVideo ? (
            <div className="relative w-full h-full">
              <div className="absolute top-0 left-0 w-full h-full z-20">
                <div onClick={() => changeParentTab(false)} className="absolute top-0 right-0 w-1/2 h-full cursor-pointer"></div>
              </div>
              {isColinkVideoLoading && (
                <div className="absolute inset-0 flex items-center justify-center z-10">
                  <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-[112px]"></div>
                </div>
              )}
              <video
                muted={muted}
                ref={parentVideoRef}
                poster={parentVideoThumbnail}
                src={generateCloudinaryVideoUrl(parentVideoUrl, "750", "930")}
                className={`object-cover w-full h-full ${isColinkVideoLoading ? "opacity-0" : "opacity-100"} transition-opacity duration-[750ms]`}
                playsInline
                autoPlay
                onLoadedData={() => {
                  mixpanel.track("video-viewed", { location: "thank-you-page", campaignName: campaign?.title, stashlinkId: stashlink?.id });
                  setIsColinkVideoLoading(false);
                }}
                onEnded={() => {
                  mixpanel.track("video-ended", { location: "thank-you-page", campaignName: campaign?.title, stashlinkId: stashlink?.id });
                  changeParentTab(false);
                }}
                onPlaying={() => {
                  if (hasPausedBefore) {
                    mixpanel.track("video-unpaused", {
                      location: "thank-you-page",
                      campaignName: campaign?.title,
                      stashlinkId: stashlink?.id
                    });
                  } else {
                    mixpanel.track("video-play-clicked", {
                      location: "thank-you-page",
                      campaignName: campaign?.title,
                      stashlinkId: stashlink?.id
                    });
                  }
                  setIsPlaying(true);
                }}
                onPause={() => {
                  setPausedBefore(true);
                  mixpanel.track("video-paused", { location: "thank-you-page", campaignName: campaign?.title, stashlinkId: stashlink?.id });
                  setIsPlaying(false);
                }}
              />
              <div
                onClick={() => {
                  if (parentVideoRef.current) {
                    // if video is already at end, start at beginning again
                    if (parentVideoRef.current.currentTime === parentVideoRef.current.duration) {
                      parentVideoRef.current.currentTime = 0;
                    }

                    if (parentVideoRef.current.paused) {
                      setIsPlaying(true);
                      parentVideoRef.current.play();
                    } else {
                      setIsPlaying(false);
                      parentVideoRef.current.pause();
                    }
                  }
                }}
                className={clsx(
                  "absolute flex justify-center items-start w-full h-full top-0 left-0 bg-gradient-to-t from-soft-black/0 from-30% via-soft-black/0 via-90% to-soft-black/60 to-100% transition-opacity duration-300",
                  !isPlaying ? "backdrop-blur-sm" : ""
                )}>
                {!isPlaying && (
                  <div
                    className={`h-[72px] w-[72px] rounded-full flex items-center justify-center relative  ${isNativeWebview() ? "top-[210px]" : "top-[calc(50%-72px)]"}`}
                    style={{
                      background:
                        "linear-gradient(0deg, var(--blacks-op-black-op-10, rgba(0, 0, 0, 0.1)), var(--blacks-op-black-op-10, rgba(0, 0, 0, 0.1))), linear-gradient(0deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4))"
                    }}>
                    <PlayIcon />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="absolute top-0 left-0 w-full h-full">
              <div>
                <img
                  src={generateCloudinaryImageUrl(stashlink.parentStashlink?.user.profilePhoto || "", "750", "930")}
                  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full object-cover h-full w-full"
                />
              </div>
              <div onClick={() => changeParentTab(false)} className="absolute top-0 right-0 w-1/2 h-full cursor-pointer"></div>
            </div>
          ))}

        {!showParentVideo &&
          (stashlink.thankYouMessageVideo ? (
            <div className="absolute top-0 right-0 w-full h-full overflow-hidden">
              {/* {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center z-10">
                  <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-[112px]"></div>
                </div>
              )} */}
              <video
                muted={muted}
                ref={videoRef}
                src={generateCloudinaryVideoUrl(colinkVideoUrl, "750", "930")}
                className={`object-cover w-full h-full ${isLoading ? "opacity-0" : "opacity-100"} transition-opacity duration-[750ms]`}
                autoPlay
                poster={colinkVideoThumbnail}
                playsInline
                onLoadedData={() => {
                  mixpanel.track("video-viewed", { location: "thank-you-page", campaignName: campaign?.title, stashlinkId: stashlink?.id });
                  setIsLoading(false);
                }}
                onPlaying={() => {
                  if (hasPausedBefore) {
                    mixpanel.track("video-unpaused", {
                      location: "thank-you-page",
                      campaignName: campaign?.title,
                      stashlinkId: stashlink?.id
                    });
                  } else {
                    mixpanel.track("video-play-clicked", {
                      location: "thank-you-page",
                      campaignName: campaign?.title,
                      stashlinkId: stashlink?.id
                    });
                  }
                  setIsPlaying(true);
                }}
                onEnded={() => {
                  mixpanel.track("video-ended", { location: "thank-you-page", campaignName: campaign?.title, stashlinkId: stashlink?.id });
                  mixpanel.track("continue-button-clicked-thank-you", {
                    campaignName: campaign?.title,
                    charityName: campaign?.charity?.name,
                    stashlinkId: stashlink?.id
                  });
                  if (isAmazon) {
                    setIsContinueModalOpen(true);
                  } else {
                    navigateToStashAgain();
                  }
                }}
                onPause={() => {
                  mixpanel.track("video-paused", { location: "thank-you-page", campaignName: campaign?.title, stashlinkId: stashlink?.id });
                  setIsPlaying(false);
                  setPausedBefore(true);
                }}
              />
              <div
                onClick={() => {
                  if (videoRef.current) {
                    // if video is already at end, start at beginning again
                    if (videoRef.current.currentTime === videoRef.current.duration) {
                      videoRef.current.currentTime = 0;
                    }

                    if (videoRef.current.paused) {
                      setIsPlaying(true);
                      videoRef.current.play();
                    } else {
                      setIsPlaying(false);
                      videoRef.current.pause();
                    }
                  }
                }}
                className={clsx(
                  "absolute flex justify-center items-start w-full h-full top-0 left-0 bg-gradient-to-t from-soft-black/0 from-30% via-soft-black/0 via-90% to-soft-black/60 to-100% transition-opacity duration-300",
                  !isPlaying ? "backdrop-blur-sm" : ""
                )}>
                {!isPlaying && (
                  <div
                    className={`h-[72px] w-[72px] rounded-full flex items-center justify-center relative  ${isNativeWebview() ? "top-[210px]" : "top-[calc(50%-72px)]"}`}
                    style={{
                      background:
                        "linear-gradient(0deg, var(--blacks-op-black-op-10, rgba(0, 0, 0, 0.1)), var(--blacks-op-black-op-10, rgba(0, 0, 0, 0.1))), linear-gradient(0deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4))"
                    }}>
                    <PlayIcon />
                  </div>
                )}
              </div>
              {hasNextOrPreviousMedia() && (
                <div onClick={() => changeParentTab(true)} className="absolute top-0 left-0 w-1/2 h-full cursor-pointer"></div>
              )}
            </div>
          ) : (
            <div>
              <img
                src={generateCloudinaryImageUrl(stashlink.user.profilePhoto ?? "", dynamicImageSize.width, dynamicImageSize.height)}
                className="h-full w-full object-contain"
              />
            </div>
          ))}

        {!isNativeWebview() && CTA}
        <ShareComponent
          stashUser={stashlink.parentStashlink?.user || userData}
          coLinkUser={stashlink.parentStashlink?.user ? userData : undefined}
          charityName={campaign.charity?.name}
          charityLogo={campaign.charity?.imageUrl}
          currentAmount={campaign.currentAmount + 1}
          goalAmount={campaign.goalAmount}
          shareUrl={shareUrl}
          isOpen={isShareModalOpen}
          onClose={() => setIsShareModalOpen(false)}
        />
        <ContinueModal
          isOpen={isContinueModalOpen}
          onClose={closeContinueModal}
          campaign={campaign}
          openShareModal={() => setIsShareModalOpen(true)}
          navigateToStashAgain={navigateToStashAgain}
          navigateToColink={navigateToColink}
          openWaitlistModal={() => setWaitlistModalOpen(true)}
        />
        <WaitlistModal stashUser={stashlink.parentStashlink?.user || userData} isOpen={isWaitlistModalOpen} onClose={closeWaitListModal} />
      </div>
    </>
  );
};

export default ThankYou;
